// extracted by css-extract-rspack-plugin
export default {"menuContent":"menuContent-KIxGQB","fadeIn":"fadeIn-FA3u_r","menuItem":"menuItem-u_yVHa"};